import { View } from "binder"
import { ShiftAssignment, ShiftAssignmentManipulationViewModel } from "./shiftAssignmentManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ShiftAssignmentManipulationView extends View<ShiftAssignmentManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-35814271-CAFC-4911-8E52-878A4FA5B271"
    }
    loadHtml(): string {
        let element = require('./shiftAssignmentManipulation.html').default;
        let style = require('./shiftAssignmentManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set shiftAssignments(v: ShiftAssignment) { this._shiftAssignments = v; } public get shiftAssignments(): ShiftAssignment { return this._shiftAssignments; } private _shiftAssignments: ShiftAssignment;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;
}
